import { createTheme } from '@one-thd/sui-atomic-components';

const RidgidPrimary = createTheme({
  palette: {
    mode: 'light',
    background: {
      primary: 'brand'
    }
  }
});

RidgidPrimary.palette['--sui-palette-background-primary'] = '226 114 38';

export { RidgidPrimary };
